import type { Doc } from "building-types/doc";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import { docEntityIsDeletable } from "../docEntityDeletable";
import { docEntityIsDocRefEligible } from "../docEntityDocRefEligible";
import { docEntityIsReadonly } from "../docEntityReadonly";
import { docEntityIsRenameable } from "../docEntityRenameable";
import { docEntityIsVisible } from "../docEntityVisible";
import { docEntityIsSystemEntity } from "../docSystemEntity";
import { docEntityIsClipboardReadable, docEntityIsClipboardWritable } from "./docClipboardEntityTools";
import type { DocEntityConfig } from "./docEntityConfig";
import { docEntityIsDuplicable } from "./docEntityDuplicable";
import { docEntityIsGroupable } from "./docEntityGroupable";
import { docEntityHandleToEntityRef } from "./docEntityHandleToEntityRef";
import { docEntityHandleIsLabelable } from "./docEntityHandleTools";
import { docEntityIsHidable } from "./docEntityHidable";
import { docEntityIsLockable } from "./docEntityLockable";
import type { DocEntityNodeSource } from "./docEntityNodeRegistryTypes";
import { docEntityIsReorderable } from "./docEntityReorderable";

export function docEntityGetConfig(doc: Doc, handle: DocEntityHandle, registry: DocEntityNodeSource): DocEntityConfig {
  return {
    isHidable: docEntityIsHidable(doc, handle),
    isLockable: docEntityIsLockable(doc, handle),
    isLabelable: docEntityHandleIsLabelable(handle),
    isGroupable: docEntityIsGroupable(doc, handle),
    isDeletable: docEntityIsDeletable(doc, handle),
    isVisible: docEntityIsVisible(doc, handle),
    isRenameable: docEntityIsRenameable(doc, handle),
    isDuplicable: docEntityIsDuplicable(doc, handle),
    isEntityRef: !!docEntityHandleToEntityRef(doc, handle),
    isDocRefEligible: docEntityIsDocRefEligible(doc, handle),
    isClipboardReadable: docEntityIsClipboardReadable(doc, handle, registry),
    isClipboardWritable: docEntityIsClipboardWritable(doc, handle, registry),
    isSystemEntity: docEntityIsSystemEntity(doc, handle),
    isReorderable: docEntityIsReorderable(doc, handle),
    isReadonly: docEntityIsReadonly(doc, handle),
  };
}
